import { getSchoolTimezoneOffset, isSchoolsReady } from "state/teachers/selectors";

/**
 * Inject some computed properties into notices
 * @returns {Immutable.Map}
 */
function buildNotice(state, notice) {
  const timezoneOffset = getSchoolTimezoneOffset(state, notice.get("schoolID"));
  const expandedNoticeID = state.getIn([ "teachers", "expandedNoticeID" ]);
  const expanded = notice.get("id") === expandedNoticeID;
  return notice.toMap()
    .set("timezoneOffset", timezoneOffset)
    .set("expanded", expanded)
}

/**
 * Get properties of the notice with the given ID
 * @returns {Immutable.Map}
 */
export function getNoticeByID(state, noticeID) {
  const notice = state.getIn(['teachers', 'notices', noticeID] );
  return buildNotice(state, notice);
}

/**
 * Get IDs of all notices for the given school, sorted by postedDate
 * @returns {Immutable.Seq}
 */
export function getSchoolNoticeIDList(state, schoolID) {
  return state.getIn(['teachers', 'notices']).valueSeq()
    // filter for given school
    .filter((notice) => notice.get("schoolID") === schoolID)
    // sort by timestamp (DESCending)
    .sortBy((notice) => notice.get("postedDate"))
    .reverse()
    .map((notice) => notice.get("id"))
}

/**
 * @returns {boolean}
 */
export function isNoticesLoading(state) {
  return state.getIn([ "teachers", "isNoticesLoading" ]);
}

/**
 * Return true if schools and notices are loaded
 * @returns {boolean}
 */
export function isNoticesReady(state) {
  return isSchoolsReady(state) && !isNoticesLoading(state);
}

/**
 * @returns {Immutable.List}
 */
export function getRecentNotices(state, count) {
  return state.getIn(["teachers", "notices"])
    .sortBy(notice => notice.get("postedDate"))
    .takeLast(count)
    .reverse()
    .toList();
}

/**
 * @returns {string}
 */
export function getGoToNoticeID(state) {
  return state.getIn(["teachers", "goToNoticeID"]);
}



// WEBPACK FOOTER //
// ./src/state/teachers/selectors/notices.js